import React, { useEffect, useState } from "react";
import MiniDrawer from "../Components/MiniDrawer";
import Radium, { StyleRoot } from "radium";
import axios from "axios";
import "./PregaStart.css";
import configData from "../config.json";

const PregaStart = () => {
  const [users, setUsers] = useState([]);
  const [expandedUserId, setExpandedUserId] = useState(null);

  useEffect(() => {
    axios
      .get(`${configData.SERVER_API_URL}/users/get_All_Confirm_User`, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((response) => {
        console.log("API response:", response.data);
        setUsers(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const filteredAndSortedUsers = users
    .filter(
      (user) =>
        !["pending", "param", "PENDING", "", null].includes(user.payment_status)
    )
    .sort((a, b) => {
      if (a.payment_status === "SUCCESS" && b.payment_status !== "SUCCESS")
        return -1;
      if (b.payment_status === "SUCCESS" && a.payment_status !== "SUCCESS")
        return 1;
      return 0;
    });

  const toggleExpanded = (userId) => {
    setExpandedUserId((prevId) => (prevId === userId ? null : userId));
  };

  const safeParse = (data) => {
    try {
      const parsed = JSON.parse(data);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error("JSON parsing error:", e);
      return [];
    }
  };

  const handleVisitedChange = (userId, currentStatus) => {
    const newStatus = !currentStatus;
    const newStatusValue = newStatus ? 1 : 0;

    const confirmMessage = newStatus
      ? "Are you sure you want to confirm the user's visit?"
      : "Are you sure you want to revoke the visit confirmation?";

    if (!window.confirm(confirmMessage)) return;

    axios
      .post(
        `${configData.SERVER_API_URL}/consultation/patient_visited_confirmation`,
        { id: userId, is_visited: newStatusValue },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        }
      )
      .then((res) => {
        console.log(`Visited status updated for user ID ${userId}:`, res.data);

        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.id === userId ? { ...user, is_visited: newStatusValue } : user
          )
        );

        // Show upload section only if checked
        // setExpandedUserId(newStatus ? userId : null);
        if (newStatus) {
          setExpandedUserId(userId); // Show report upload if marked  visited
        } else {
          setExpandedUserId(null); // Hidesection if unmarked
        }
      })
      .catch((err) => {
        console.error("Error updating visited status:", err);
        alert("Failed to update visit status. Please try again.");
      });
  };

  const handleFileUpload = (e, userId) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", userId);

    axios
      .post(
        "https://admin.myprega.com/user/upload_files_pregnancy_conform",
        formData,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "*/*",
          },
        }
      )
      .then((res) => {
        console.log(`File uploaded for user ID ${userId}`, res.data);

        // Update UI to reflect upload
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.id === userId ? { ...user, is_report_uploaded: true } : user
          )
        );
        alert("Report uploaded successfully!");
      })
      .catch((err) => {
        console.error("File upload failed:", err);
        alert("Failed to upload report. Please try again.");
      });
  };

  return (
    <div
      style={{
        display: "flex",
        maxWidth: "100%",
      }}
    >
      <MiniDrawer />
      <div className="confirmed-users-wrapper">
        <h2 className="page-title">PregaStart Package</h2>
        <div className="user-grid">
          {filteredAndSortedUsers.map((user) => (
            <div key={user.id} className="user-card">
              <h3 className="user-name">{user.full_name}</h3>
              <p>
                <strong>User ID:</strong> {user.id}
              </p>
              <p>
                <strong>Phone:</strong> {user.number}
              </p>
              <p>
                <strong>Email:</strong> {user.email}
              </p>
              <p>
                <strong>UPT result:</strong> {user.UPT}
              </p>
              {/* <p><strong>Payment:</strong> {user.payment_status}</p> */}
              {/* <p><strong>Paid:</strong> {user.amount}</p> */}

              {user.date && (
                <div className="date-section">
                  <p className="label">
                    Preferred date for gynecologist consultation:
                  </p>
                  <div className="pill-container">
                    {safeParse(user.date).map((d, i) => (
                      <span key={i} className="pill blue">
                        {d}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {user.sonog_date && (
                <div className="date-section">
                  <p className="label">Preferred date for first ultrasound:</p>
                  <div className="pill-container">
                    {safeParse(user.sonog_date).map((d, i) => (
                      <span key={i} className="pill green">
                        {d}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div className="visited-checkbox">
                <label htmlFor={`visited-${user.id}`}>Patient Visited</label>
                <input
                  type="checkbox"
                  id={`visited-${user.id}`}
                  checked={user.is_visited}
                  onChange={() => handleVisitedChange(user.id, user.is_visited)}
                />
              </div>

              {expandedUserId === user.id && user.is_visited && (
                <div className="report-upload-section">
                  <p>
                    <strong>Upload Report:</strong>
                  </p>

                  {!user.is_report_uploaded && (
                    <div>
                      <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileUpload(e, user.id)}
                      />
                    </div>
                  )}
                </div>
              )}
              {user.is_report_uploaded ? (
                <p>
                  <strong>Report Uploaded:</strong> Yes
                </p>
              ) : (
                <p>
                  <strong>Report Uploaded:</strong> No
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PregaStart;
